










import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({ name: 'card' })
export default class CardComponent extends Vue {
  @Prop() public img!: string;
  @Prop() public title!: string;
  @Prop() public description!: string;
}
